import { getDeviceInfo, getIsMobileOrTablet, } from '@office-start/device-detection-utility';
import { KnownDocumentActionIdPrefix, } from '@office-start/document-types';
import { IconNames } from '@office-start/fabric-icon-subset-utility';
import { ShareControlMode } from '@office-start/share-types';
import { format } from '@office-start/string-formatter-utility';
import { createDownloadAction } from './createDownloadAction';
import { createOpenFileLocationAction } from './createOpenFileLocationAction';
import { createOpenInBrowserAction } from './createOpenInBrowserAction';
import { createOpenInNativeAppAction } from './createOpenInNativeAppAction';
import { createShareAction } from './createShareAction';
/**
 * Create document actions
 * @param item content to perform actions on
 * @param index index of item in list
 * @param targetElementId where any actions should be attached in the DOM
 * @param menuResources strings for the menu
 * @param componentContext needed for sharing
 * @param identity needed for sharing
 * @param isDarkMode whether or not we're in dark mode (sharing)
 * @returns An array of Document actions
 *
 * @deprecated this flow is only used in non-Office 2.0 scenarios.
 *
 * @todo Turn params into an options object and uncomment/remove lint warning
 */
// eslint-disable-next-line max-params
export function createDocumentActions(item, index, targetElementId, menuResources, componentContext, identity, isDarkMode) {
    var isMobileOrTabletDevice = getIsMobileOrTablet();
    var openInBrowserActionTitleSentence = menuResources.openInBrowserActionTitleSentence, openInDesktopActionTitleSentence = menuResources.openInDesktopActionTitleSentence, shareActionTitle = menuResources.shareActionTitle, copyLinkActionTitle = menuResources.copyLinkActionTitle, downloadActionTitle = menuResources.downloadActionTitle, openFileLocationActionTitleSentence = menuResources.openFileLocationActionTitleSentence, openInAppActionTitle = menuResources.openInAppActionTitle;
    var documentActions = [];
    var openInBrowserAction = createOpenInBrowserAction(item);
    if (openInBrowserAction) {
        documentActions.push({
            title: openInBrowserActionTitleSentence,
            ariaLabel: openInBrowserActionTitleSentence,
            id: "".concat(KnownDocumentActionIdPrefix.openInBrowser).concat(item.app),
            extension: item.extension,
            executeAction: openInBrowserAction,
        });
    }
    var openInNativeAppAction = createOpenInNativeAppAction(item);
    if (openInNativeAppAction) {
        var title = isMobileOrTabletDevice
            ? format(openInAppActionTitle, item.app)
            : openInDesktopActionTitleSentence;
        documentActions.push({
            title: title,
            ariaLabel: title,
            id: "".concat(KnownDocumentActionIdPrefix.openInApp).concat(item.app),
            extension: item.extension,
            executeAction: openInNativeAppAction,
        });
    }
    var shareAction = createShareAction(item, index, componentContext, identity, targetElementId, isDarkMode);
    if (shareAction) {
        documentActions.push({
            title: shareActionTitle,
            icon: IconNames.Share,
            iconCssClass: 'ms-fcl-nd',
            ariaLabel: shareActionTitle,
            id: KnownDocumentActionIdPrefix.share,
            executeAction: shareAction,
        });
    }
    var copyLinkAction = createShareAction(item, index, componentContext, identity, targetElementId, isDarkMode, ShareControlMode.CopyLink);
    if (copyLinkAction) {
        documentActions.push({
            title: copyLinkActionTitle,
            icon: IconNames.Link,
            ariaLabel: copyLinkActionTitle,
            id: KnownDocumentActionIdPrefix.copyLink,
            executeAction: copyLinkAction,
        });
    }
    // $TODO: evlave re-enable when fixed
    if (getDeviceInfo().browser.browserType !== "Edge" /* BrowserType.Edge */) {
        var downloadAction = createDownloadAction(item, componentContext);
        if (downloadAction) {
            documentActions.push({
                title: downloadActionTitle,
                icon: IconNames.Download,
                ariaLabel: downloadActionTitle,
                id: KnownDocumentActionIdPrefix.download,
                executeAction: downloadAction,
            });
        }
    }
    var openFileLocationAction = createOpenFileLocationAction(item);
    if (openFileLocationAction) {
        documentActions.push({
            title: openFileLocationActionTitleSentence,
            icon: IconNames.OpenFile,
            ariaLabel: openFileLocationActionTitleSentence,
            id: KnownDocumentActionIdPrefix.openFileLocation,
            executeAction: openFileLocationAction,
        });
    }
    return documentActions;
}
//# sourceMappingURL=createDocumentActions.js.map